
const baseReducerHandler = (state, loading, error) => {
  return Object.assign({}, state, {
    loading,
    error
  });
};

export default baseReducerHandler;
